import { useState } from 'react';
import { toast } from 'sonner';
import { Bot, ScanText, Star, Puzzle } from 'lucide-react';
import { Switch } from '../ui/switch';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { ownerApi, apiError, fmtDate } from './ownerApi';

const ICONS = { ai_chatbot: Bot, ai_doc_reading: ScanText, five_star: Star };

const AddonRow = ({ addon, onSaved }) => {
  const [end, setEnd] = useState(addon.end_date || '');
  const Icon = ICONS[addon.key] || Puzzle;
  const save = async (enabled, end_date) => {
    try { onSaved((await ownerApi.put(`/platform-owner/addons/${addon.key}`, { enabled, end_date: end_date || null })).data); toast.success(`${addon.label} güncellendi`); }
    catch (e) { toast.error(apiError(e)); }
  };
  const expired = addon.enabled && !addon.active;
  return (
    <div className="flex flex-wrap items-center gap-4 py-4" data-testid={`owner-addon-${addon.key}`}>
      <Icon className="h-5 w-5 text-orange-500" />
      <div className="min-w-[160px] flex-1">
        <p className="font-medium text-slate-900">{addon.label}</p>
        <p className={`text-xs ${addon.active ? 'text-emerald-600' : 'text-rose-600'}`} data-testid={`owner-addon-state-${addon.key}`}>
          {addon.active ? `Açık · bitiş ${fmtDate(addon.end_date)}` : expired ? `Süresi doldu (${fmtDate(addon.end_date)})` : 'Kapalı'}
        </p>
      </div>
      <Input type="date" value={end} onChange={e => setEnd(e.target.value)} className="w-40" data-testid={`owner-addon-end-${addon.key}`} />
      <Button variant="outline" size="sm" onClick={() => save(addon.enabled, end)} data-testid={`owner-addon-save-${addon.key}`}>Tarihi kaydet</Button>
      <Switch checked={addon.enabled} onCheckedChange={(v) => save(v, end)} data-testid={`owner-addon-switch-${addon.key}`} />
    </div>
  );
};

export const AddonsCard = ({ addons, onSaved }) => (
  <section className="rounded-2xl border border-slate-200 bg-white p-6" data-testid="owner-addons-card">
    <h2 className="text-lg font-semibold text-slate-900">Eklenti Yönetimi</h2>
    <p className="text-sm text-slate-500">Kapalı veya süresi dolan eklentiler uygulamada görünmez.</p>
    <div className="mt-2 divide-y divide-slate-100">{addons.map(a => <AddonRow key={a.key + a.end_date + a.enabled} addon={a} onSaved={onSaved} />)}</div>
  </section>
);
